<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :form="form"
    :title="$t('model.riskAssessmentResult')"
    resource="risk_assessment_results"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/risk_assessment_results.js';
import _ from 'lodash';

@Component
export default class RiskAssessmentResults extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [

    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'score',
      'risk_assessment_level',
      'account',
      'risk_assessment',
      type === 'show' && {
        key: 'risk_assessment_answers',
        renderCell: (h, { props: { value } }) => {
          return _.map(
            value,
            (v, i) => {
              return (<div>
                <div>{i + 1}. {v.risk_assessment_question.content}</div>
                <div>{_.map(v.risk_assessment_question.risk_assessment_options, (o, i) => <div style={_.includes(v.risk_assessment_option_ids, o.id) ? 'color: red' : '' }>&nbsp;&nbsp;&nbsp;{i + 1}.{o.content}</div>)}</div>
              </div>)
            }
          );
        }
      },
      { key: 'file', width: 300 },
      'created_at',
      'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [

    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'risk_assessment_results.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'risk_assessment_results.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  /**
    * @param {Object} scope -表格 scope 数据
    * @param {Object} scope.selection - 表格已选择行数据
    * @param {Object} sourcePageScope
    * @param {Function} sourcePageScope.remove - sourcePage删除方法
    * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
    */
  batchActions({ selection }, { resource }) {
    const exportClick = async (selection) => {
      if (selection.length === 0) {
          await this.$request.get(`/${resource}/export`, { ...this.$route.query });
      } else {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query, id_in: _.map(selection, item => item.id) });
      }

      this.$message.success(this.$t('exporting'));
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i>{this.$t('export')}</el-button>
    ];
  }
}

export const route = [
  {
    path: '/risk_assessment_results',
    name: 'risk_assessment_results.index',
    component: RiskAssessmentResults,
    props: {
      type: 'index',
    }
  },
  {
    path: '/risk_assessment_results/new',
    name: 'risk_assessment_results.new',
    component: RiskAssessmentResults,
    props: {
      type: 'new',
    }
  },
  {
    path: '/risk_assessment_results/:id',
    name: 'risk_assessment_results.show',
    component: RiskAssessmentResults,
    props: {
      type: 'show',
    }
  },
  {
    path: '/risk_assessment_results/:id/edit',
    name: 'risk_assessment_results.edit',
    component: RiskAssessmentResults,
    props: {
      type: 'edit'
    }
  }
]
</script>
